<template>
  <div class="infinite-scroll-list">
    <div class="list">
      <slot />
    </div>
    <div ref="scrollMonitorEl" class="monitor"></div>
  </div>
</template>
<script setup>
  import scrollMonitor from 'scrollmonitor'
  import { onMounted, ref } from 'vue'
  const scrollMonitorEl = ref(null)
  const watcher = ref(null)

  const emit = defineEmits(['load-more-fn'])

  const emitDataLoadMore = () => {
    return emit('load-more-fn')
  }

  const setScrollMonitor = () => {
    const monitorEl = scrollMonitorEl.value
    watcher.value = scrollMonitor.create(monitorEl, 500)
    watcher.value.enterViewport(emitDataLoadMore)
  }

  onMounted(() => {
    setScrollMonitor()
  })
</script>
<style lang="scss">
  .infinite-scroll-list {
    position: relative;
    .list {
      overflow: hidden;
    }
  }
</style>
